import differenceBy from 'lodash/differenceBy';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  MultiSelectTextFieldControlMessageMeta,
  NumberFieldMultiSelectControlMessageMeta,
} from 'api/conversations';
import { FieldOption } from 'api/tasks';

export const MultiSelectTextControlMessage: FC<{
  meta:
    | MultiSelectTextFieldControlMessageMeta
    | NumberFieldMultiSelectControlMessageMeta;
  rootKey: string;
  userName: string;
}> = ({ meta, rootKey, userName }) => {
  const intl = useIntl();
  const { oldValue = [], newValue = [] } = meta;
  let keyForString = rootKey;
  let diff: FieldOption<string>[] = [];

  if (oldValue.length < newValue.length) {
    keyForString += '.MULTI_SELECT.ADDED';
    diff = differenceBy(newValue, oldValue, 'value');
  } else {
    keyForString += '.MULTI_SELECT.REMOVED';
    diff = differenceBy(oldValue, newValue, 'value');
  }

  return (
    <FormattedMessage
      id={keyForString}
      values={{
        changedByUserName: userName,
        label: meta.fieldLabel || meta.fieldName,
        diff: intl.formatList(diff.map((d) => d.label)),
      }}
    />
  );
};
